import { useEffect } from 'react'
import dashedLine from '../images/dashed-curved-more-info-line-mobile.svg'
import { select } from 'd3'

type MobileScreen5Props = {
  anchorRef: React.RefObject<HTMLDivElement>
}

const MobileScreen5 = ({ anchorRef }: MobileScreen5Props) => {
  const { y } = anchorRef.current?.getBoundingClientRect()!
  useEffect(() => {
    const ref = anchorRef.current
    select(ref).style('z-index', 1000).style('pointer-events', 'none')
    return () => {
      select(ref).style('z-index', 'initial').style('pointer-events', 'initial')
    }
  }, [anchorRef])
  return (
    <>
      <div
        className="flex flex-col items-center w-[294px] gap-1 absolute"
        style={{
          left: `25%`,
          top: `${y - 200}px`,
        }}
      >
        <p className="text-orange font-decimal text-[22px]">
          Zoom and pan around the map to explore, and click on any data point on
          the map to learn more about the organization.
        </p>
        <img src={dashedLine} alt="dashed line" />
      </div>
    </>
  )
}
export default MobileScreen5
